export const ART_EVENT_TABLE_HEADERS = {
  artEventName: 'art-event-name-table-header',
  startTime: 'start-time-table-header',
  endTime: 'end-time-table-header',
  status: 'status-table-header',
};

export const TABLE_HEADERS = [
  'edit-art-event-actions-table-header',
  ART_EVENT_TABLE_HEADERS.artEventName,
  ART_EVENT_TABLE_HEADERS.startTime,
  ART_EVENT_TABLE_HEADERS.endTime,
  ART_EVENT_TABLE_HEADERS.status,
];
